import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-page-about-us",
  templateUrl: "./page-about-us.component.html",
  styleUrls: ["./page-about-us.component.scss"],
  standalone: false,
})
export class PageAboutUsComponent implements OnInit {
  form = {
    name: "",
    email: "",
    subject: "",
    message: "",
  };

  constructor() {}

  ngOnInit(): void {}
}
